import React from "react";

export const columns = onClickToDeduct => [
  {
    title: "Nom",
    dataIndex: "user_fullname",
    keh: "user_fullname",
    width: 100,
    render: name => <div className="ml-4">{name}</div>
  },
  {
    title: "Entreprise",
    dataIndex: "user_portail2_nomEntreprise",
    key: "user_portail2_nomEntreprise",
    width: 200
  },
  {
    title: "Montant total validé",
    dataIndex: "total_validated",
    key: "total_validated",
    width: 100,
    render: value => <div className="py-6">{Number.parseFloat(value).toFixed(2)} €</div>
  },
  {
    title: "Montant des avances",
    width: 100,
    key: "avances",
    children: [
      {
        title: "Ponctuels",
        dataIndex: "deduction",
        key: "avancededuction",
        width: 150,
        render: value => <div className="py-6">{value ? Number.parseFloat(value).toFixed(2) : 0} €</div>
      },
      // { DOES NOT EXIST IN THE API
      //   title: "Permanentes",
      //   dataIndex: "number",
      //   key: "avancepermanent",
      //   width: 150,
      //   render: value => <div className="py-6">{value ? Number.parseFloat(value).toFixed(2) : 0} €</div>
      // }
    ]
  },
  {
    title: "Montant des déductions",
    key: "deductions",
    width: 100,
    children: [
      {
        title: "Contraventions",
        dataIndex: "total_fine",
        key:"deductionfine",
        width: 150,
        render: value => <div className="py-6">{value ? Number.parseFloat(value).toFixed(2) : 0} €</div>
      },
      {
        title: "Kilomètres perso",
        dataIndex: "total_km",
        key: "deductionkm",
        width: 150,
        render: value => <div className="py-6">{value ? Number.parseFloat(value).toFixed(2) : 0} €</div>
      },
      {
        title: "Frais postaux",
        dataIndex: "total_postal",
        key: "deductionpostal",
        width: 150,
        render: value => <div className="py-6">{value ? Number.parseFloat(value).toFixed(2) : 0} €</div>
      }
    ]
  },
  {
    title: "Total à rembourser",
    dataIndex: "total",
    key: "total",
    width: 100,
    render: value => <div className="py-6">{Number.parseFloat(value).toFixed(2)} €</div>
  },
  {
    title: "Statut",
    dataIndex: "status",
    key: "status",
    width: 100,
    render: status => <div className="font-bold">{status.label}</div>
  },
  {
    title: "Actions",
    dataIndex: "user_id",
    key: "user_id",
    width: 100,
    render: userId => {
      return (
        <a className="flex cursor-pointer underline font-bold text-orange-400" onClick={() => onClickToDeduct(userId)}>
          A déduire
        </a>
      );
    }
  }
];



// WEBPACK FOOTER //
// src/modules/presence/transfers/transfersEmployee/TransfersEmployee.utils.js